import { Dispatcher } from '@npm-registry/helpers/dispatcher';

export const cartGetRequestError = new Dispatcher();
